<template lang="pug">
    span
        a.navItem(v-if="isLink" :href="to" target="_blank")  {{ text }}
        router-link.navItem(v-else :to="to") {{ text }}
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            to: VueTypes.string.def(''),
            text: VueTypes.string.def(''),
            isLink: VueTypes.bool.def(false),
        },
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .navItem
        display: inline-block
        padding: 12px 15px
        color: $theme.white
        text-decoration: none
        transition: color 0.3s
        white-space: nowrap
        font-size: 18px

        &:last-child
            margin-right: 0

        &:hover
        &.router-link-active
        &.isActive
            color: $theme.secondary
            opacity: 1

    @media screen and (max-width: $grid-breakpoints.lg - 1)
        .navItem
            padding: 12px 6px
            font-size: 16px

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .navItem
            padding: 12px 6px
            font-size: 14px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .navItem
            padding: 12px 4px
            font-size: 12px
</style>
